import { deleteRequest } from '..';

const deleteChatbotSession = async (sessionId: string) => {
  const requestUrl = `chatbot-api/chat-sessions/${sessionId}?hardDelete=true`;
  await deleteRequest(requestUrl);
};

export default deleteChatbotSession;
